import React from 'react';
import { Row, Col } from 'react-bootstrap';

// TODO: Consider adding company stats (projects completed, years in business, etc.)

const CompanyOverview = () => {
  const features = [
    '25+ years of industry experience',
    'Licensed and insured professionals',
    'Quality craftsmanship and materials',
    'On-time and on-budget project delivery',
    'Transparent communication throughout the process',
    'Comprehensive warranty on all work',
  ];

  console.log('[CompanyOverview] Rendering company overview section');

  return (
    <section className="section">
      <h2 className="section-title">About DD Construction</h2>
      <Row className="align-items-center">
        <Col lg={6} className="mb-5 mb-lg-0">
          <p>
            DD Construction is a premier residential construction company with
            over 25 years of experience in delivering high-quality construction
            services. We specialize exclusively in residential construction,
            renovations, additions, and custom home building projects.
          </p>
          <p>
            Our team of skilled professionals is committed to excellence, using
            the finest materials and innovative techniques to bring your vision
            to life. We pride ourselves on our attention to detail, timely
            project completion, and exceptional customer service.
          </p>
          <p className="mb-0">
            At DD Construction, we believe in building not just structures, but
            relationships. Our client-centered approach ensures that we
            understand your needs and exceed your expectations on every project.
          </p>
        </Col>
        <Col lg={6}>
          <div className="why-choose-box">
            <h4>Why Choose Us</h4>
            {features.map((feature, index) => (
              <div className="feature-item" key={index}>
                <div className="feature-icon">
                  <i className="bi bi-check2"></i>
                </div>
                <span className="feature-text">{feature}</span>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default CompanyOverview;
